<template>
	<messagebox titles='添加部门' @sub="sub" @shut="shut" height="auto">
		<div class="form">
			<el-form :model="addForm" :rules="rules" ref="addForm" label-width="80px" label-position="right">
				<el-form-item label="上级部门" prop="upperlevel">
					<el-treeselect v-model="addForm.upperlevel" placeholder="请输入搜索内容" :data="treeData" :props="props" :search="false">
					</el-treeselect>
				</el-form-item>
				<el-form-item label="部门名称" prop="name">
					<el-input v-model="addForm.name"></el-input>
				</el-form-item>
			</el-form>
		</div>
	</messagebox>
</template>

<script>
	export default {
		data() {
			return {
				addForm: {
					name: "",
					upperlevel: 1,
				},
				rules: {
					name: [{
						required: true,
						message: '请输入部门名称',
						trigger: 'blur'
					}]
				},
				flowId:"",
				treeData: [{
					flowId: 1,
					name: 'a',
					children: [{
							flowId: 11,
							name: 'a-1',
							children: [{
								flowId: 111,
								name: 'a-1-1',
							}],
						},
						{
							flowId: 12,
							name: 'a-2',
						}
					]
				}, {
					flowId: 2,
					name: 'b',
					children: [{
							flowId: 21,
							name: 'b-1',
						},
						{
							flowId: 22,
							name: 'b-2',
						}
					]
				}],
				props: {
					label: 'name',
					value: 'flowId',
					children: 'children',
				}
			}
		},
		methods: {
			sub() {
				this.$refs.addForm.validate((valid) => {
					if(valid) {
						console.dir(this.addForm);
//						this.$emit('sub');
					} 
				});
			},
			shut() {
				this.$emit('shut');
			}
		},
	}
</script>

<style src="../../assets/css/common/table.less" scoped lang="less"></style>
<style scoped lang="less">
	.form {
		margin: 23px 0;
	}
	
	.el-select {
		width: 100%;
	}
</style>